// React
import React, { useEffect, useState } from "react";

// MUI
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Collapse,
  Autocomplete,
  Paper,
  Tooltip,
  CircularProgress,
} from "@mui/material";

//MUI ICON
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";

// Formik
import { useFormik } from "formik";
import * as Yup from "yup";

//Components
import Dropzone from "components/Dropzone_one";
import CustomDropzone from "components/Dropzone";
import {
  GradientButton,
  GradientOutline,
  GradientButtonOutline,
  GradientShadow,
} from "components/GradientButton";
import Form from "components/Form/FormPawn";

// API
import api from "_api";

// Other
import { Divider } from "antd";
import Swal from "sweetalert2";
import ReactDOM from "react-dom";
import SaveIcon from "assets/images/SaveIcon.svg";

import { PaymentChannelOptions } from "contants/options";
// ข้อมูลสัญชาติ
import nationalities from "data/nationalities_th.json";
import RenderFieldsCustomerPawn from "components/Pawn/RenderFieldsCustomer";

// ฟังก์ชันสำหรับสร้าง validation schema ให้กับฟอร์ม
const generateValidationSchema = (productBoxes) => {
  // Dynamic validation fields from productBoxes
  const validationFields = productBoxes.reduce((schema, box) => {
    schema[`product_name_${box.id}`] =
      Yup.string().required(`โปรดระบุชื่อสินค้า`);
    // schema[`category_id_${box.id}`] = Yup.string().required(`โปรดระบุหมวดหมู่`);
    schema[`total_amount_${box.id}`] = Yup.number().required(`โปรดระบุจำนวน`);
    schema[`price_${box.id}`] = Yup.number().required(`โปรดระบุราคา`);
    // schema[`total_price_${box.id}`] =
    //   Yup.number().required(`โปรดระบุจำนวนทั้งหมด`);
    return schema;
  }, {});

  // Static validation fields
  const staticFields = {
    prefix: Yup.string().required("โปรดระบุคำนำหน้า"),
    fullName: Yup.string().required("โปรดระบุชื่อ-สกุล"),
    // idCardNumber: Yup.string()
    //   .length(13, "รหัสบัตรประชาชนต้องมี 13 หลัก")
    //   .matches(/^\d+$/, "รหัสบัตรประชาชนต้องเป็นตัวเลขเท่านั้น")
    //   .required("โปรดระบุรหัสบัตรประชาชนหรือเลขหนังสือเดินทาง"),
    idCardNumber: Yup.string().when("nationality", {
      is: (value) => value === "ไทย",
      then: (schema) =>
        schema
          .matches(/^\d+$/, "รหัสบัตรประชาชนต้องเป็นตัวเลขเท่านั้น")
          .length(13, "รหัสบัตรประชาชนต้องมี 13 หลัก")
          .required("โปรดระบุรหัสบัตรประชาชน"),
      otherwise: (schema) =>
        schema
          .matches(
            /^[A-Za-z0-9]+$/,
            "เลขหนังสือเดินทางต้องเป็นตัวอักษรหรือตัวเลขเท่านั้น"
          )
          .min(6, "เลขหนังสือเดินทางต้องมีอย่างน้อย 6 หลัก")
          .max(20, "เลขหนังสือเดินทางกรอกได้มากสุด 20 หลัก")
          .required("โปรดระบุเลขหนังสือเดินทาง"),
    }),
    phoneNumber: Yup.string()
      .min(9, "หมายเลขโทรศัพท์ต้องมีอย่างน้อย 9 หลัก")
      .max(10, "หมายเลขโทรศัพท์กรอกได้มากสุด 10 หลัก")
      .matches(/^\d+$/, "หมายเลขโทรศัพท์ต้องเป็นตัวเลขเท่านั้น")
      .required("โปรดระบุหมายเลขโทรศัพท์"),
    address: Yup.string().required("โปรดระบุที่อยู่"),
    nationality: Yup.string().required("โปรดระบุสัญชาติ"),
  };

  // Merge dynamic and static fields
  return Yup.object({
    ...validationFields, // Dynamic fields
    ...staticFields, // Static fields
  });
};

const conditionPawn = [
  {
    label: "ระยะเวลา (เดือน)",
    name: "total_month",
    type: "number",
    required: true,
    // width: "90%",
    // specialText: "เดือน",
  },
  {
    label: "อัตราดอกเบี้ย",
    name: "interest_rate",
    type: "number",
    required: true,
  },
];

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field หมวดหมู่
const categoryOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];

const ModalCreate = ({ open, onClose, selectedProduct, fetchProductData }) => {
  // ตัวแปรสำหรับเก็บข้อมูลรูปภาพ
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);

  // ตัวแปรสำหรับเก็บข้อของ Box แสดง Product
  const [productBoxes, setProductBoxes] = useState([
    { id: 1, isExpanded: false },
  ]);
  const [expandedRow, setExpandedRow] = useState(null); // เก็บการแสดงผลของ Row ในการ Explaned
  const [statusSave, setStatusSave] = useState(false); // เก็บ status หลังจากมีการเพิ่ม Box
  const [currentStep, setCurrentStep] = useState(1); // Track the current step
  // const [selectedOption, setSelectedOption] = useState(1); // For selecting the display count option
  const [isHovered, setIsHovered] = useState(false);
  const [activeButton, setActiveButton] = useState("pawnContract");

  //เก็บตัวแปร id หลังจากสร้าง product เสร็จ
  const [newIds, setNewIds] = useState([
    {
      product_id: 0,
      amount: 0,
      total_price: 0,
    },
  ]);

  // loading and status success for create order
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  // keep order when create order success
  const [order, setOrder] = useState(null);

  // const [newAmount, setNewAmount] = useState([]);

  //ฟังก์ชันแสดง Explanded
  const handleExpandClick = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  //ฟังก์ชันลบ Box
  const handleDeleteBox = async (rowId) => {
    if (productBoxes.length > 1) {
      let product_id = formik.values[`product_id_${rowId}`];
      if (product_id) {
        try {
          const response = await api.product.deleteProduct(product_id);
          if (response) {
            setProductBoxes((prevBoxes) =>
              prevBoxes.filter((box) => box.id !== rowId)
            );
            setNewIds((prevIds) =>
              prevIds.filter((item) => item.product_id !== product_id)
            );
            // delete product id in formik
            const newValues = Object.fromEntries(
              Object.entries(formik.values).filter(
                ([key]) => !key.endsWith(`_${rowId}`)
              )
            );
            formik.setValues(newValues);
          }
        } catch (error) {
          console.error("Error deleting product:", error);
        }
      } else {
        setProductBoxes((prevBoxes) =>
          prevBoxes.filter((box) => box.id !== rowId)
        );
      }
    } else {
      alert("Cannot delete the last remaining box.");
    }
  };

  //ฟังก์ชันเปลี่ยนหน้า
  const handleNextStep = () => {
    setCurrentStep(currentStep + 1); // Go to the next "page"
  };

  //ฟังก์ชันสำหรับการเปลี่ยนหน้าแสดงผลใน Modal
  const handleBackToStep1 = () => {
    setCurrentStep(1); // Reset back to the first step if needed
  };

  // ฟังก์ชันเพิ่ม product box
  const addProductBox = () => {
    if (productBoxes.length < 15) {
      setProductBoxes([
        ...productBoxes,
        { id: productBoxes.length + 1, isExpanded: false },
      ]);
      setStatusSave(false);
    } else {
      alert("คุณสามารถเพิ่มสินค้าได้สูงสุด 15 รายการเท่านั้น");
    }
  };

  // ฟังก์ชัน explan
  const toggleExpand = (boxId) => {
    setProductBoxes(
      productBoxes.map((box) =>
        box.id === boxId ? { ...box, isExpanded: !box.isExpanded } : box
      )
    );
  };

  // สร้างรหัสตัวแปรตามจำนวน Box ที่เพิ่ม
  const generateInitialValues = (productBoxes) => {
    // Static initial values
    const initialValues = {
      prefix: "",
      fullName: "",
      idCardNumber: "",
      phoneNumber: "",
      address: "",
      nationality: "ไทย",

      total_month: "",
      interest_rate: "",
      payment_channel: "",
    };

    // Dynamic initial values based on productBoxes
    const dynamicValues = productBoxes.reduce((values, { id }) => ({
      ...values,
      [`product_id_${id}`]: "",
      [`product_code_${id}`]: "",
      [`product_code_com_${id}`]: "",
      [`product_name_${id}`]: "",
      [`category_id_${id}`]: "",
      [`detail_${id}`]: "",
      [`blemishes_${id}`]: "",
      [`size_${id}`]: "",
      [`total_amount_${id}`]: "",
      [`price_${id}`]: "",
      [`total_price_${id}`]: "",
      [`notes_${id}`]: "",
      [`images_${id}`]: [],
    }));

    return {
      ...initialValues,
      ...dynamicValues,
    };
  };

  // นับจำนวน Box
  const productBoxCount = productBoxes.length;

  // console.log("display new id in array", productBoxes);

  // Function to convert object to FormData
  const transformObjectToFormData = (obj) => {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      if (key === "category_id" && value?.id) {
        // Append category id if it's an object with id
        formData.append(key, value.id);
      } else if (Array.isArray(value)) {
        // Handle arrays like image uploads
        value.forEach((item, index) => {
          if (item instanceof File) {
            // Append files in FormData
            formData.append(`${key}[${index}]`, item);
          } else {
            // Append other array items
            formData.append(`${key}[${index}]`, item);
          }
        });
      } else {
        // Append other values directly
        formData.append(key, value);
      }
    });

    return formData;
  };

  // Formik hook
  const formik = useFormik({
    initialValues: generateInitialValues(productBoxes),
    validationSchema: generateValidationSchema(productBoxes),
    onSubmit: async (values, { resetForm }) => {
      console.log("values of customer", values);
      try {
        setLoading(true);
        const customerData = {
          prefix: values.prefix,
          fullName: values.fullName,
          idCardNumber: values.idCardNumber,
          phoneNumber: values.phoneNumber,
          address: values.address,
          nationality: values.nationality || "ไทย",
          file: files2.map((fileObj) => fileObj.file),
        };

        const customerFormData = transformObjectToFormData(customerData);
        const customerResponse = await api.pawn.createCustomer(
          customerFormData
        );

        if (customerResponse.isStatus) {
          // If customer creation is successful, proceed to create orders for each product box
          const validNewIds = newIds.filter(
            (item) =>
              item.product_id !== 0 &&
              item.amount !== 0 &&
              item.total_price !== 0
          );

          const orderDataArray = productBoxes.map((box) => {
            return {
              product: validNewIds.length > 0 ? validNewIds : [], // Use empty array if no valid products
              customer: {
                id: customerResponse.data.id,
              },
              order: {
                total_month: values.total_month,
                interest_rate: values.interest_rate,
              },
              payment_channel: values.payment_channel,
            };
          });

          // Loop through the orderDataArray to create orders for each product
          if (orderDataArray.length > 0) {
            const orderResponse = await api.pawn.createOrder(orderDataArray[0]);
            // console.log("Order response for first item:", orderResponse);

            if (!orderResponse.isStatus) {
              console.error("Error creating order for first item.");
              throw new Error("Error creating order for first item.");
            }

            setOrder(orderResponse.data);

            setTimeout(() => {
              setLoading(false);
              setIsSuccess(true);
            }, 1000);
          }
        } else {
          setLoading(false);
          console.error("Error creating customer.");
        }
      } catch (error) {
        setLoading(false);
        console.error("Error submitting form:", error);
        alert(`Error submitting form: ${error.message}`);
      }
    },
    validateOnChange: true,
    validateOnBlur: true,
  });

  const handlePrintPDF = async () => {
    if (order) {
      await api.pawn
        .getPrintPdfPawnOrder(order?.createdOrder?.id)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/pdf" })
          );
          window.open(url, "_blank");
        })
        .catch((error) => {
          console.error("Error exporting excel:", error);
        });
    }
  };

  const handleClose = () => {
    setFiles1([]); // Clear product images
    setFiles2([]); // Clear customer images
    formik.resetForm();
    setCurrentStep(1);
    setProductBoxes([{ id: 1, isExpanded: false }]);
    setNewIds([]);
    setLoading(false);
    setIsSuccess(false);
    setOrder(null);
    onClose();
    fetchProductData();
  };

  // ฟังก์ชันลบรูป
  const handleImageDelete = (boxId, imageIndex) => {
    const currentImages = formik.values[`images_${boxId}`] || [];

    // Safeguard against undefined or null images array
    const updatedImages = currentImages.filter(
      (_, index) => index !== imageIndex
    );

    formik.setFieldValue(`images_${boxId}`, updatedImages);
  };

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFields = (fields) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>

            {field.type === "autocomplete" ? (
              <Autocomplete
                id={field.name}
                options={categoryOptions}
                getOptionLabel={(option) => option.label}
                value={formik.values.category_id}
                onChange={(event, newValue) => {
                  if (!field.disabled) {
                    formik.setFieldValue("category_id", newValue);
                  }
                }}
                disabled={field.disabled}
                fullWidth
                sx={{
                  flexGrow: 1,
                  ".MuiAutocomplete-inputRoot": {
                    height: "40px",
                    padding: "0px !important", // Ensure consistent padding
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name={field.name}
                    error={
                      formik.touched[field.name] &&
                      Boolean(formik.errors[field.name])
                    }
                    helperText={
                      formik.touched[field.name] && formik.errors[field.name]
                    }
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                )}
              />
            ) : (
              <TextField
                disabled={field.disabled}
                id={field.name}
                name={field.name}
                type={field.type}
                value={formik.values[field.name]}
                onChange={formik.handleChange}
                error={
                  formik.touched[field.name] &&
                  Boolean(formik.errors[field.name])
                }
                helperText={
                  formik.touched[field.name] && formik.errors[field.name]
                }
                fullWidth
                InputProps={{
                  sx: { height: "40px", padding: "0px" }, // Ensure consistent height and padding
                  inputProps: {
                    style: {
                      "-moz-appearance": "textfield",
                      "-webkit-appearance": "none",
                      appearance: "none",
                    },
                    // maxLength:
                    //   field.name === "idCardNumber"
                    //     ? 13
                    //     : field.name === "phoneNumber"
                    //     ? 10
                    //     : undefined,
                    // inputMode: field.type === "text" ? "numeric" : undefined,
                    // pattern: field.type === "text" ? "[0-9]*" : undefined,
                    min:
                      field.name === "total_month"
                        ? 1
                        : field.name === "interest_rate"
                        ? 0
                        : undefined,
                    max:
                      field.name === "total_month"
                        ? 5
                        : field.name === "interest_rate"
                        ? 100
                        : undefined,
                  },
                }}
                onInput={(e) => {
                  if (
                    field.name === "total_month" &&
                    (e.target.value < 1 || e.target.value > 5)
                  ) {
                    e.target.value = "";
                  }

                  if (
                    field.name === "interest_rate" &&
                    (e.target.value < 0 || e.target.value > 100)
                  ) {
                    e.target.value = "";
                  }
                }}
                {...getFieldProps(field.name)}
              />
            )}
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  // ฟังก์ชันการแสดงฟิลด์ของ Product
  const renderProductBoxes = () => {
    return productBoxes.map((box) => (
      <Box
        key={box.id}
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center" // Add this to center items vertically
          onClick={() => toggleExpand(box.id)}
        >
          <Typography variant="subtitle1">สินค้าชิ้นที่ {box.id}</Typography>
          <div>
            <IconButton
              disabled={productBoxes.length > 1 ? false : true}
              size="small"
              color="#ccc"
              onClick={(e) => {
                e.stopPropagation(); // Prevent toggleExpand from triggering on delete click
                handleDeleteBox(box.id); // Call the delete function
              }}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              size="small"
              color="#ccc"
              onClick={() => handleExpandClick(box.id)}
              style={{
                transform: expandedRow === box.id ? "rotate(180deg)" : "none",
                transition: "transform 0.2s ease-in-out",
                marginLeft: "10px",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </div>
        </Box>
        <Collapse in={box.isExpanded}>
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Divider sx={{ borderColor: "#00BB9F", borderWidth: 1 }} />
            {/* Product Code2 Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>รหัส 2 {""}</Typography>
                    <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                      <InfoIcon style={{ color: "#e5e5e5", marginRight: 10 }} />
                    </Tooltip>
                  </div>
                </Grid>

                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    name={`product_code_com_${box.id}`}
                    value={formik.values[`product_code_com_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`product_code_com_${box.id}`] &&
                      Boolean(formik.errors[`product_code_com_${box.id}`])
                    }
                    helperText={
                      formik.touched[`product_code_com_${box.id}`] &&
                      formik.errors[`product_code_com_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Name Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ชื่อสินค้า{""}
                    <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    name={`product_name_${box.id}`}
                    value={formik.values[`product_name_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`product_name_${box.id}`] &&
                      Boolean(formik.errors[`product_name_${box.id}`])
                    }
                    helperText={
                      formik.touched[`product_name_${box.id}`] &&
                      formik.errors[`product_name_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Category Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    หมวดหมู่{""}
                    <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Autocomplete
                    id={`category_id_${box.id}`}
                    options={categoryOptions}
                    getOptionLabel={(option) => option.label || ""} // Ensure label is retrieved correctly
                    value={
                      categoryOptions.find(
                        (option) =>
                          option.id === formik.values[`category_id_${box.id}`]
                      ) // Ensure default is selected if not set
                    }
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        `category_id_${box.id}`,
                        newValue?.id || "" // Store only the id in Formik's state
                      );
                    }}
                    fullWidth
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        height: "40px", // Set consistent height
                        padding: "0 8px", // Use slight padding to keep input structure intact
                      },
                      ".MuiOutlinedInput-root": {
                        height: "40px", // Ensure consistent height in outer wrapper
                      },
                      ".MuiAutocomplete-input": {
                        padding: "0px", // Minimal padding for input text
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name={`category_id_${box.id}`} // Use correct name for validation
                        error={
                          formik.touched[`category_id_${box.id}`] &&
                          Boolean(formik.errors[`category_id_${box.id}`])
                        }
                        helperText={
                          formik.touched[`category_id_${box.id}`] &&
                          formik.errors[`category_id_${box.id}`]
                        }
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Detail Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>รายละเอียด</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    name={`detail_${box.id}`}
                    value={formik.values[`detail_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`detail_${box.id}`] &&
                      Boolean(formik.errors[`detail_${box.id}`])
                    }
                    helperText={
                      formik.touched[`detail_${box.id}`] &&
                      formik.errors[`detail_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Blemishes Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>ตำหนิ</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    name={`blemishes_${box.id}`}
                    value={formik.values[`blemishes_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`blemishes_${box.id}`] &&
                      Boolean(formik.errors[`blemishes_${box.id}`])
                    }
                    helperText={
                      formik.touched[`blemishes_${box.id}`] &&
                      formik.errors[`blemishes_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Size Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>ขนาด</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    name={`size_${box.id}`}
                    value={formik.values[`size_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`size_${box.id}`] &&
                      Boolean(formik.errors[`size_${box.id}`])
                    }
                    helperText={
                      formik.touched[`size_${box.id}`] &&
                      formik.errors[`size_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Total amount Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    จำนวน{" "}
                    <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    name={`total_amount_${box.id}`}
                    value={formik.values[`total_amount_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`total_amount_${box.id}`] &&
                      Boolean(formik.errors[`total_amount_${box.id}`])
                    }
                    helperText={
                      formik.touched[`total_amount_${box.id}`] &&
                      formik.errors[`total_amount_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Price Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ราคาทุน{""}
                    <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    type="number"
                    name={`price_${box.id}`}
                    value={formik.values[`price_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`price_${box.id}`] &&
                      Boolean(formik.errors[`price_${box.id}`])
                    }
                    helperText={
                      formik.touched[`price_${box.id}`] &&
                      formik.errors[`price_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Total Price Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ราคารวม{""}
                    <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    name={`total_price_${box.id}`}
                    value={
                      formik.values[`total_amount_${box.id}`] &&
                      formik.values[`price_${box.id}`]
                        ? Number(formik.values[`total_amount_${box.id}`]) *
                          Number(formik.values[`price_${box.id}`])
                        : ""
                    }
                    // No onChange because total_price is calculated dynamically
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`total_price_${box.id}`] &&
                      Boolean(formik.errors[`total_price_${box.id}`])
                    }
                    helperText={
                      formik.touched[`total_price_${box.id}`] &&
                      formik.errors[`total_price_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                    disabled // Disable input since it's calculated
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Notes Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>หมายเหตุ</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    name={`notes_${box.id}`}
                    value={formik.values[`notes_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`notes_${box.id}`] &&
                      Boolean(formik.errors[`notes_${box.id}`])
                    }
                    helperText={
                      formik.touched[`notes_${box.id}`] &&
                      formik.errors[`notes_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Image Row */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 2 }}>
                รูปทรัพย์
              </Typography>
              <Grid item xs={12}>
                <CustomDropzone
                  files={formik.values[`images_${box.id}`] || []} // Access images based on box.id
                  initialUrls={initialProductUrls[`images_${box.id}`]} // If you have initial URLs per box
                  setFiles={(newFiles) =>
                    formik.setFieldValue(`images_${box.id}`, newFiles)
                  } // Set the images for this specific box
                  setError={setError1}
                  onDelete={handleImageDelete}
                />

                {error1 && (
                  <Typography variant="caption" color="error">
                    {error1}
                  </Typography>
                )}
              </Grid>

              {error1 && (
                <Typography variant="caption" color="error">
                  {error1}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
            <Button
              variant="outlined"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={async () => {
                // formik.handleSubmit();
                try {
                  let product_id = formik.values[`product_id_${box.id}`];

                  // Existing images from formik state
                  const existingImages =
                    formik.values[`images_${box.id}`] || [];

                  // Separate new files (without id) from existing images (with id)
                  const newFiles = existingImages
                    .filter((img) => !img.id)
                    .map((fileObj) => fileObj.file);
                  const combinedFiles = newFiles.filter(Boolean); // New files to be uploaded

                  // Collect product details
                  const boxValues = {
                    product_code: formik.values[`product_code_${box.id}`],
                    product_code_com:
                      formik.values[`product_code_com_${box.id}`],
                    product_name: formik.values[`product_name_${box.id}`],
                    category_id: formik.values[`category_id_${box.id}`],
                    detail: formik.values[`detail_${box.id}`],
                    blemishes: formik.values[`blemishes_${box.id}`],
                    size: formik.values[`size_${box.id}`],
                    total_amount: formik.values[`total_amount_${box.id}`],
                    price: formik.values[`price_${box.id}`],
                    total_price: formik.values[`total_price_${box.id}`],
                    notes: formik.values[`notes_${box.id}`],
                    files: combinedFiles,
                  };

                  const formData = transformObjectToFormData(boxValues);

                  if (!product_id) {
                    // Create new product
                    const productResponse = await api.pawn.createProduct(
                      formData
                    );

                    console.log("productResponse.isStatus", productResponse);
                    if (productResponse && productResponse.isStatus) {
                      const newProductId = productResponse.data.product_id;
                      // console.log("มันเข้าตรงนี้นะ", newProductId);

                      const newProductCode = productResponse.data.product_code;
                      setStatusSave(true);

                      // console.log("debug 2", newProductCode);

                      const newProductAmount =
                        productResponse.data.total_amount;

                      // console.log("debug 3", newProductAmount);

                      const newProductPrice = productResponse.data.total_price;

                      // console.log("debug 4", newProductPrice);

                      // Set product_id in Formik state
                      await formik.setFieldValue(
                        `product_id_${box.id}`,
                        newProductId
                      );
                      await formik.setFieldValue(
                        `product_code_${box.id}`,
                        newProductCode
                      );

                      //เดี๋ยวมาแก้ตรงนี้นะ
                      // setNewIds([...newIds, newProductId]);
                      // setNewAmount([...newAmount, newProductAmount]);

                      setNewIds(
                        [
                          ...newIds,
                          {
                            product_id: newProductId,
                            amount: newProductAmount,
                            total_price: newProductPrice,
                            product_code: newProductCode,
                          },
                        ].filter(
                          (item) =>
                            item.product_id !== 0 &&
                            item.amount !== 0 &&
                            item.total_price !== 0
                        )
                      );

                      // Extract and set the pictures (ensure they are formatted properly)
                      const pictures = productResponse.data.pictures.map(
                        (pic, index) => ({
                          id: pic.id,
                          url: pic.pic, // Server returns URL
                          name:
                            existingImages[index]?.name || `Image ${index + 1}`, // Retain file name
                          size: existingImages[index]?.size || 0, // Retain file size
                        })
                      );
                      console.log("pictures after create", pictures);

                      // Update Formik state with the returned images
                      await formik.setFieldValue(`images_${box.id}`, pictures);
                    }
                  } else {
                    // Existing product update
                    const updateValues = {
                      "product.product_id": product_id,
                      "product.product_code":
                        formik.values[`product_code_${box.id}`],
                      "product.product_code_com":
                        formik.values[`product_code_com_${box.id}`],
                      "product.product_name":
                        formik.values[`product_name_${box.id}`],
                      "product.category_id":
                        formik.values[`category_id_${box.id}`],
                      "product.detail": formik.values[`detail_${box.id}`],
                      "product.blemishes": formik.values[`blemishes_${box.id}`],
                      "product.size": formik.values[`size_${box.id}`],
                      "product.total_amount":
                        formik.values[`total_amount_${box.id}`],
                      "product.price": formik.values[`price_${box.id}`],
                      "product.total_price":
                        formik.values[`total_price_${box.id}`],
                      "product.notes": formik.values[`notes_${box.id}`],
                      "product.deleteFiles":
                        deletedImageIds?.length > 0 ? deletedImageIds : [], // Handle deleted images
                      files: combinedFiles,
                    };

                    const formDataUpdate =
                      transformObjectToFormData(updateValues);
                    const updateProductResponse =
                      await api.product.updateProduct(formDataUpdate);

                    if (updateProductResponse.isStatus) {
                      // Handle image updates
                      const updatedPictures =
                        updateProductResponse.data.pictures.map((pic) => ({
                          id: pic.id,
                          url: pic.pic,
                        }));

                      await formik.setFieldValue(
                        `images_${box.id}`,
                        updatedPictures
                      );

                      console.log(
                        `Product ${box.id} updated successfully.`,
                        updatedPictures
                      );
                    } else {
                      console.error(
                        "Failed to update the product.",
                        updateProductResponse
                      );
                    }
                  }

                  console.log("Formik values after save:", formik.values);
                } catch (error) {
                  console.error(`Error saving product ${box.id}:`, error);
                }
              }}
              style={{
                height: "50px",
                width: "200px",
                color: "#000",
                borderColor: "#ddd",
                borderRadius: "12px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>
                บันทึกข้อมูล
              </Typography>
              {isHovered && <CheckCircleIcon color="success" />}
            </Button>
          </Box>
        </Collapse>
      </Box>
    ));
  };
  const renderFieldsPayment = () => {
    return (
      <Box
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid container spacing={2} style={{ marginTop: "10px" }}>
          {/* Product Payment Channel Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ช่องทางการจ่าย{""}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  id={`payment_channel`}
                  options={PaymentChannelOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    PaymentChannelOptions.find(
                      (opt) => opt.id === formik.values.payment_channel
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      `payment_channel`,
                      newValue ? newValue.id : ""
                    );
                  }}
                  sx={{
                    ".MuiAutocomplete-inputRoot": {
                      height: "40px",
                      padding: "0px 0px 0px 5px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name={`payment_channel`}
                      error={
                        formik.touched.payment_channel &&
                        Boolean(formik.errors.payment_channel)
                      }
                      helperText={
                        formik.touched.payment_channel &&
                        formik.errors.payment_channel
                      }
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        sx: { height: "40px" },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  };

  // console.log("display formik.values", formik.values);
  //กรณีปิดหน้าต่าง Modal
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <!-- Left side icon/picture -->
            <div style="margin-right: 20px;">
              <img src="${SaveIcon}" alt="warning icon" width="300" height="300"/>
            </div>
      
            <!-- Right side text and buttons -->
            <div style="flex: 1;">
              <h2 style="font-size: 24px; color: #333;">ยืนยันการบันทึกหรือไม่</h2>
              <div id="custom-buttons" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <!-- React buttons will be injected here -->
              </div>
            </div>
          </div>
        `,
        showCancelButton: false, // Disable default buttons
        showConfirmButton: false, // Disable default buttons
        customClass: {
          container: "swal2-container-custom",
        },
        didOpen: () => {
          document.querySelector(".swal2-container-custom").style.zIndex = 1500;

          // Render your React button components after the Swal modal opens
          ReactDOM.render(
            <>
              <GradientButton
                onClick={() => {
                  // Handle cancel behavior
                  Swal.close(); // Close Swal
                }}
                style={{ width: "100%", marginBottom: "10px" }} // Make full width
              >
                ยกเลิก
              </GradientButton>
              <GradientButtonOutline
                onClick={() => {
                  // Close the current Swal first before showing the confirmation Swal
                  Swal.close();
                  formik.resetForm();
                  setFiles1([]); // Clear product images
                  setFiles2([]); // Clear customer images
                  setInitialProductUrls([]); // Clear initial product image URLs
                  // setInitialCustomerUrls([]);
                  setDeletedImageIds([]);
                  onClose();
                  setNewIds([]);
                }}
                style={{ width: "100%" }}
              >
                ตกลง
              </GradientButtonOutline>
            </>,
            document.getElementById("custom-buttons") // Inject React components into this div
          );
        },
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
      setNewIds([]);
    }
  };

  // Function to handle button click
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName); // Set the clicked button as active
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  // ใช้สำหรับการคิดค่าของ ราคา * จำนวน = จำนวนทั้งหมดแล้วนำไปเก็บไว้ใน Formik id นั้นๆ
  // useEffect(() => {
  //   productBoxes.forEach((box) => {
  //     const totalAmount = formik.values[`total_amount_${box.id}`];
  //     const price = formik.values[`price_${box.id}`];

  //     if (totalAmount && price) {
  //       const totalPrice = Number(totalAmount) * Number(price);
  //       formik.setFieldValue(`total_price_${box.id}`, totalPrice);
  //     }
  //   });
  // }, [formik.values, productBoxes]);

  // start websocket
  const [intendPresentFlag, setIntendPresentFlag] = useState(true);

  let wSocket = null;

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const setAutoReadOptions = () => {
    const cmdNIDAutoRead = document.getElementById("chkAutoRead").checked;
    const cmdIDNumber = document.getElementById("chkAutoNIDNumber").checked;
    const cmdText = document.getElementById("chkAutoNIDText").checked;
    const cmdphoto = document.getElementById("chkAutoNIDPhoto").checked;
    const JS_OBJ = {
      Command: "SetAutoReadOptions",
      AutoRead: cmdNIDAutoRead,
      IDNumberRead: cmdIDNumber,
      IDTextRead: cmdText,
      IDATextRead: true,
      IDPhotoRead: true,
    };
    var jsonStr = JSON.stringify(JS_OBJ);
    wSocketSend(jsonStr);
  };

  const wSocketSend = (jsonStr) => {
    // console.log("wSocketSend jsonStr > ", jsonStr);
    wSocket.send(jsonStr);
  };

  const clearScreen = () => {
    console.log("call clearScreen");
    //setTimeout(() => {
    formik.resetForm();
    setFiles2([]);
  };

  const putToScreen = async (jsObj) => {
    try {
      let prefix = "";
      let fullName = "";
      let address = "";
      const IDNum = jsObj.ID_Number;
      const IDText = jsObj.ID_Text;
      const IDPhoto = jsObj.ID_Photo;
      const status = jsObj.Status;
      if (status == 0) {
        if (IDText != "") {
          const NIDData = IDText.split("#");
          const prefix_T = NIDData[1];
          const firstName_T = NIDData[2];
          const lastName_T = NIDData[4];
          prefix = prefix_T;
          fullName = firstName_T + " " + lastName_T;
          address =
            NIDData[9] +
            " " +
            NIDData[10] +
            " " +
            NIDData[11] +
            " " +
            NIDData[12] +
            " " +
            NIDData[13] +
            "\r\n" +
            NIDData[14] +
            " " +
            NIDData[15] +
            " " +
            NIDData[16];
        }
      }
      // 2. อัปเดต Formik values พร้อมกัน
      await Promise.all([
        formik.setFieldValue("prefix", prefix),
        formik.setFieldValue("idCardNumber", IDNum),
        formik.setFieldValue("fullName", fullName),
        formik.setFieldValue("address", address),
      ]);
      // await formik.setValues({
      //   ...formik.values,
      //   idCardNumber: IDNum,
      //   fullName: fullName,
      //   address: address,
      //   isFromCard: true
      // }, false); // false = ไม่ต้อง validate

      // 3. อัปเดต touched หลังจาก values ถูกตั้งค่า
      formik.setTouched({
        ...formik.touched,
        idCardNumber: true,
        fullName: true,
        address: true,
      });

      // 4. ตรวจสอบ validation ใหม่
      setTimeout(() => {
        formik.validateForm();
      }, 50);

      // 5. อัปเดตรูปภาพ (ถ้ามี)
      if (IDPhoto != null) {
        const photoUrl = `data:image/jpeg;base64,${IDPhoto}`;
        const fileName = `id_card_${Date.now()}.jpg`;
        const idCardFile = dataURLtoFile(photoUrl, fileName);
        const nidCardFile = {
          file: idCardFile,
          url: photoUrl,
          name: fileName,
          status: "complete",
          isFromCard: true,
        };
        setFiles2([nidCardFile]);
      }
    } catch (error) {
      console.error("Error in putToScreen:", error);
    }
  };

  const onGetMessage = (jsonString) => {
    const msgObj = JSON.parse(jsonString);
    if (msgObj.Message == "AgentStatusE") {
      if (msgObj.Status == 1) {
        setAutoReadOptions();
      } else {
        alert("ERROR Code :" + msgObj.Status);
      }
    }

    if (msgObj.Message == "CardStatusChangeE") {
      if (msgObj.Status == -1004) {
        alert("ERROR Code :" + msgObj.Status);
        return;
      } else if (msgObj.Status == 1) {
        clearScreen();
        setIntendPresentFlag(false);
      } else if (msgObj.Status == -16) {
        setIntendPresentFlag(true);
        clearScreen();
      } else if (msgObj.Status == 0) {
        alert("Card Status: Unknown");
        clearScreen();
      } else {
        alert("ERROR Code :" + msgObj.Status);
      }
    }

    if (msgObj.Message == "ReadingProgressE") {
    }

    if (msgObj.Message == "AutoReadIDCardE") {
      putToScreen(msgObj);
    }

    if (msgObj.Message == "AutoSelectReaderE") {
    }
  };

  useEffect(() => {
    if (open) {
      wSocket = new WebSocket("ws://localhost:14820/TDKWAgent");
      wSocket.onopen = () => {
        console.log("WebSocket opened");
      };

      wSocket.onmessage = function (evt) {
        onGetMessage(evt.data);
      };

      wSocket.onerror = (error) => {
        console.log("WebSocket: error", error);
      };

      return () => {
        wSocket.close();
        console.log("WebSocket closed");
      };
    }
  }, [open]);

  useEffect(() => {
    console.log("files2 changed >>> ", files2);
  }, [files2]);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        //ป้องกันการกดเบื้องหลังแล้วหลุด
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      sx={{
        borderRadius: "8px",
      }}
    >
      {currentStep === 1 ? (
        <>
          {/* หน้าที่ 1 : Form */}
          <DialogTitle style={{ backgroundColor: "#F1F2F7" }}>
            <Typography variant="h4">ขายฝากสินค้า</Typography>
          </DialogTitle>
          <DialogContent style={{ backgroundColor: "#F1F2F7" }}>
            <form onSubmit={formik.handleSubmit}>
              {/* Render the product boxes */}
              <input
                type="checkbox"
                class="form-check-input mx-3"
                id="chkAutoRead"
                onclick="setAutoReadOptions();"
                checked="checked"
                style={{ display: "none" }}
              ></input>
              <input
                type="checkbox"
                class="form-check-input"
                id="chkAutoNIDNumber"
                onclick="setAutoReadOptions();"
                checked="checked"
                style={{ display: "none" }}
              ></input>
              <input
                type="checkbox"
                class="form-check-input"
                id="chkAutoNIDText"
                checked="checked"
                onclick="setAutoReadOptions();"
                style={{ display: "none" }}
              ></input>
              <input
                type="checkbox"
                class="form-check-input"
                id="chkAutoNIDPhoto"
                checked="checked"
                onclick="setAutoReadOptions();"
                style={{ display: "none" }}
              ></input>
              <Grid item xs={12} sx={{ mx: 2 }}>
                <RenderFieldsCustomerPawn
                  formik={formik}
                  setCustomerImage={setFiles2}
                  // images={
                  //   selectedProduct ? selectedProduct.customer_image : null
                  // }
                  // images={
                  //   files2.length > 0
                  //     ? files2
                  //     : selectedProduct
                  //     ? selectedProduct.customer_image
                  //     : []
                  // }
                  images={
                    selectedProduct ? selectedProduct.customer_image : files2
                  }
                  disabled={!!selectedProduct}
                />

                <Grid items xs={12}>
                  {/* Render the product boxes */}
                  <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                    ข้อมูลสินค้า
                  </Typography>
                  {renderProductBoxes()}
                </Grid>

                {/* Button to add new product box and display count */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-end"
                  sx={{ mt: 2 }}
                >
                  <Typography>{productBoxCount} / 15</Typography>
                  {productBoxes.length >= 15 ||
                  !productBoxes.every(
                    (box) => formik.values[`product_id_${box.id}`]
                  ) ? (
                    <GradientOutline
                      onClick={addProductBox}
                      disabled={productBoxes.length >= 15 || !statusSave}
                      style={{ marginLeft: "10px" }}
                    >
                      <Typography style={{ marginRight: "8px" }}>
                        เพิ่มสินค้า
                      </Typography>
                      <AddCircleIcon fontSize="medium" />
                    </GradientOutline>
                  ) : (
                    <GradientButton
                      onClick={addProductBox}
                      style={{ marginLeft: "10px" }}
                    >
                      <Typography style={{ marginRight: "8px" }}>
                        เพิ่มสินค้า
                      </Typography>
                      <AddCircleIcon fontSize="medium" />
                    </GradientButton>
                  )}
                </Box>

                <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                  เงื่อนไขการขายฝาก
                </Typography>
                <Paper
                  sx={{
                    p: 2,
                    borderRadius: "12px",
                    boxShadow: "none",
                    border: "1px solid #ddd",
                  }}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      {renderFields(conditionPawn)}
                    </Grid>
                  </Grid>
                </Paper>
                <Grid items xs={12}>
                  <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                    รายละเอียดการรับขายฝาก
                  </Typography>
                  {renderFieldsPayment()}
                </Grid>
              </Grid>
            </form>
          </DialogContent>

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{
                    borderRadius: "12px", // Make the button circular
                    minWidth: "40px", // Adjust the width
                    minHeight: "40px", // Adjust the height
                    padding: 0, // Remove padding to center the icon better
                    borderColor: "#c4c4c4", // Light grey border
                    color: "#6c6c6c", // Light grey icon color
                    display: "flex", // Ensure flexbox is used
                    alignItems: "center", // Center vertically
                    justifyContent: "center", // Center horizontally
                    "&:hover": {
                      borderColor: "#a0a0a0", // Darker grey on hover
                    },
                  }}
                >
                  <ArrowBackIosIcon
                    fontSize="small"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </Button>
                {productBoxes.every(
                  (box) => formik.values[`product_id_${box.id}`]
                ) ? (
                  <GradientButtonOutline type="submit" onClick={handleNextStep}>
                    ดูตัวอย่าง
                  </GradientButtonOutline>
                ) : null}
              </Grid>
            </Grid>
          </DialogActions>
        </>
      ) : (
        <>
          {/* Step 2: Confirmation Page */}
          <DialogTitle>
            <Typography variant="h4">ตัวอย่างแบบฟอร์มรายการขายฝาก</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              {/* Left Side: PDF Preview (Scrollable) */}
              <Grid
                item
                xs={8}
                style={{
                  backgroundColor: "#f0f0f0",
                  padding: "20px",
                  height: "650px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                <Form data={formik.values} />
              </Grid>

              {/* Right Side: The Form or other content */}
              <Grid
                item
                xs={4}
                display={"flex"}
                flexDirection={"column"}
                style={{ padding: "20px" }}
              >
                <GradientShadow
                  isActive={activeButton === "pawnContract"}
                  onClick={() => handleButtonClick("pawnContract")}
                  style={{ margin: "10px" }}
                >
                  ใบขายฝาก
                </GradientShadow>

                {/* <GradientShadow
                  isActive={activeButton === "saleRenewal"}
                  onClick={() => handleButtonClick("saleRenewal")}
                  style={{ margin: "10px" }}
                >
                  ใบขายฝาก / ต่ออายุ
                </GradientShadow> */}
                {/* Content for the right side */}
              </Grid>
            </Grid>
          </DialogContent>

          {/* <Divider style={{ marginTop: "0", marginBottom: "16px", mx: 2 }} /> */}

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              // backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <GradientButtonOutline
                  // GradientButtonOutlineon
                  onClick={handleBackToStep1}
                >
                  ยกเลิก
                </GradientButtonOutline>
                <Grid>
                  {isSuccess ? (
                    <>
                      <GradientButtonOutline
                        sx={{
                          width: "120px",
                          marginRight: "20px",
                        }}
                        endIcon={
                          <CheckCircleIcon
                            sx={{
                              width: "16px",
                              height: "16px",
                            }}
                          />
                        }
                        id="btn-success"
                        onClick={handleClose}
                      >
                        เสร็จสิ้น
                      </GradientButtonOutline>
                      <GradientButton
                        id="btn-print-pdf"
                        onClick={handlePrintPDF}
                        sx={{ width: "100px" }}
                      >
                        พิมพ์
                      </GradientButton>
                    </>
                  ) : (
                    <>
                      <GradientButton
                        type="submit"
                        onClick={formik.handleSubmit}
                        style={{ marginRight: "20px", width: "150px" }}
                        disabled={loading}
                        endIcon={
                          loading ? (
                            <CircularProgress
                              color="inherit"
                              size={15}
                              thickness={5}
                            />
                          ) : null
                        }
                      >
                        บันทึก
                      </GradientButton>
                      <Tooltip
                        title={
                          <Typography
                            sx={{
                              fontSize: "14px",
                            }}
                          >
                            กรุณากดบันทึกก่อนพิมพ์
                          </Typography>
                        }
                        arrow={true}
                        placement="top"
                        disableHoverListener={isSuccess} // ปิด tooltip ถ้า isSuccess = true
                        disableFocusListener={isSuccess}
                      >
                        <span>
                          <GradientButtonOutline
                            disabled={!isSuccess}
                            sx={{
                              width: "100px",
                              border: "1px solid #ccc",
                            }}
                          >
                            พิมพ์
                          </GradientButtonOutline>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ModalCreate;
